module.exports = __webpack_public_path__ + "img/1723615239409-WhatsApp Image 2024-08-14 at 13.45.29.jpeg.a002e972.webp";